import React from "react";
import { useCssMediaQuery } from "../../hooks/useCssMediaQuery";
import { MobileAnimatedCard } from "./MobileAnimatedCard";
import { DefaultAnimatedCard } from "./DefaultAnimatedCard";

export interface AnimatedCardProps {
  variant?: "default" | "desktop-mobile-alternate";
  domId?: string;
  domRef?: any;
  isSelected?: boolean;
  isDisabled?: boolean;
  isDisabledHoverAnim?: boolean;
  isFooterHidden?: boolean;

  // event handler props
  onClick?: (e: any) => void;
  onMouseEnter?: (e: any) => void;
  onMouseLeave?: (e: any) => void;
  onRender?: (el: HTMLElement) => void;

  // render props
  renderFooter: () => React.ReactElement;
  renderBody: () => React.ReactElement;

  // style props
  footerHeight?: any;
  borderRadius: any;
  style?: {
    wrapper?: React.CSSProperties;
  };
}

export function AnimatedCard(props: AnimatedCardProps) {
  const { md: mdDown } = useCssMediaQuery("down");

  if (mdDown) return <MobileAnimatedCard {...props} />;
  return <DefaultAnimatedCard {...props} />;
}
